<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <v-col cols="12">
          <v-card
            color="white"
            dark
            elevation="24"
            class="rounded-xl"
            style="padding: 2em"
          >
            <v-row dense>
              <v-col cols="12">
                <v-alert
                  outlined
                  type="error"
                  text
                  prominent
                  border="left"
                  style="margin-top: 1em"
                  v-if="formErrors.length > 0"
                >
                  <ul>
                    <li v-for="(error, index) in formErrors" :key="index">
                      • {{ error }}
                    </li>
                  </ul>
                </v-alert>
                Complétez les informations
              </v-col>
              <v-col cols="12" md="5">
                <v-combobox
                  light
                  v-model="jobBoardJobModel"
                  :items="items"
                  :loading="isLoading"
                  :search-input.sync="search"
                  prepend-inner-icon="mdi-electron-framework"
                  chips
                  small-chips
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="symbol"
                  label="Métier, mots clés ou entreprise"
                  solo
                  multiple
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Entrer un métier, mots clés ou entreprise pour
                        rechercher
                        <strong>des offres</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" md="4">
                <v-combobox
                  light
                  v-model="where"
                  :items="locationItems"
                  :loading="locationIsLoading"
                  :search-input.sync="locationSearch"
                  prepend-inner-icon="mdi-map-marker-radius-outline"
                  chips
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="symbol"
                  label="Où"
                  v-on:keyup="locationFieldKeyUpListerner"
                  solo
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Entrer une ville, une commune, une préfecture, etc...
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  elevation="24"
                  x-large
                  rounded
                  color="primary"
                  style="width: 100%"
                  v-on:click="searchJob"
                >
                  <v-icon left> mdi-magnify</v-icon>
                  Rechercher
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense class="pa-3" v-if="displayLastResearch">
              <v-col cols="12" md="8" offset-md="2">
                <ViewLastJobSearchHistory
                  :parentFormUpdateCallback="updateFormJob"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-if="displayResults">
                <v-card
                  color="white"
                  dark
                  elevation="0"
                  class="rounded-xl mt-3"
                >
                  <v-card-title
                    style="
                      color: #6b6868;
                      padding-left: 1.5em;
                      text-align: center;
                    "
                    class="text-lg-h4 font-weight-light"
                    >Résultats
                  </v-card-title>
                  <v-card-subtitle
                    style="color: #6b6868; padding-left: 3em; padding-top: 1em"
                  >
                    <p class="font-weight-light text-lg-h5">
                      {{ jobsItems.length }} offres d'emploi correspondent à vos
                      critères.
                    </p>
                    <v-alert
                      icon="mdi-email-multiple-outline"
                      prominent
                      text
                      type="info"
                    >
                      <p class="font-weight-light text-lg-h6">
                        Simplifiez-vous la vie ! Recevez par email les nouveaux
                        emplois correspondant à cette recherche
                      </p>
                      <p>
                        <v-btn
                          elevation="24"
                          large
                          rounded
                          color="primary"
                          style="position: absolute; right: 0px"
                          v-on:click="createNewAlert"
                        >
                          <v-icon left> mdi-bell-plus-outline</v-icon>
                          Créer une alerte
                        </v-btn>
                      </p>
                    </v-alert>
                    <v-snackbar
                      v-model="snackbarAlertSuccess"
                      rounded="pill"
                      elevation="24"
                      color="green darken-3"
                    >
                      <span class="text-subtitle-1">
                        Votre alerte a bien été créée. Restez à l'affut de
                        nouvelles offres.
                      </span>
                      <template v-slot:action="{ attrs }">
                        <v-btn
                          color="pink"
                          text
                          v-bind="attrs"
                          @click="snackbarAlertSuccess = false"
                        >
                          Fermer
                        </v-btn>
                      </template>
                    </v-snackbar>
                    <v-snackbar
                      v-model="snackbarAlertFailed"
                      rounded="pill"
                      elevation="24"
                      color="red darken-3"
                    >
                      <span class="text-subtitle-1">
                        Une alerte existe déjà sur ces critères de recherche.
                      </span>
                      <template v-slot:action="{ attrs }">
                        <v-btn
                          color="black"
                          text
                          v-bind="attrs"
                          @click="snackbarAlertFailed = false"
                        >
                          Fermer
                        </v-btn>
                      </template>
                    </v-snackbar>
                    <v-snackbar
                      v-model="displayAlertErrors"
                      rounded="pill"
                      elevation="24"
                      color="red darken-3"
                    >
                      <span class="text-subtitle-1">
                        Impossible de créer une alerte sans l'intitulé du poste.
                      </span>
                      <template v-slot:action="{ attrs }">
                        <v-btn
                          color="black"
                          text
                          v-bind="attrs"
                          @click="displayAlertErrors = false"
                        >
                          Fermer
                        </v-btn>
                      </template>
                    </v-snackbar>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row dense class="pa-3">
                      <v-col cols="12">
                        <v-list two-line elevation="1" light>
                          <v-list-item-group v-model="selected" multiple>
                            <template
                              v-for="(item, index) in updateVisibleJobs"
                            >
                              <v-list-item
                                color="white"
                                :key="`${item.title}${Math.floor(
                                  Math.random() * 100000
                                )}`"
                                v-on:click="viewJobOffer(item.id)"
                              >
                                <template>
                                  <v-list-item-content>
                                    <v-list-item-title
                                      v-text="item.title"
                                      style="color: black"
                                    ></v-list-item-title>

                                    <v-list-item-subtitle
                                      style="color: #1565c0"
                                      class="font-weight-medium"
                                      v-text="item.headline"
                                    ></v-list-item-subtitle>

                                    <v-list-item-subtitle
                                      v-html="
                                        `${item.subtitle.substr(0, 50)} ...`
                                      "
                                    ></v-list-item-subtitle>
                                  </v-list-item-content>

                                  <v-list-item-action>
                                    <v-list-item-action-text
                                      v-text="item.action"
                                    ></v-list-item-action-text>
                                    <!--                                    <v-icon-->
                                    <!--                                        v-if="!active"-->
                                    <!--                                        color="grey lighten-1"-->
                                    <!--                                    >-->
                                    <!--                                      mdi-star-outline-->
                                    <!--                                    </v-icon>-->

                                    <!--                                    <v-icon-->
                                    <!--                                        v-else-->
                                    <!--                                        color="yellow darken-3"-->
                                    <!--                                    >-->
                                    <!--                                      mdi-star-->
                                    <!--                                    </v-icon>-->
                                  </v-list-item-action>
                                </template>
                              </v-list-item>

                              <v-divider
                                v-if="index < items.length - 1"
                                :key="index"
                                inset
                                style="color: #6b6868"
                              ></v-divider>
                            </template>

                            <v-pagination
                              v-model="page"
                              :length="Math.ceil(jobsItems.length / perPage)"
                              circle
                            >
                            </v-pagination>
                          </v-list-item-group>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <ViewJobOffer
                :display-dialog="displayJobOffer"
                :job-offer="jobOfferToView"
                v-if="renderViewJobModal"
                :hideModalComponentCallback="hideModalComponent"
                v-bind:display-save-button-props="true"
              />
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import ViewLastJobSearchHistory from "@/components/Candidate/ViewLastJobSearchHistory.vue";
import HttpClient from "@/services/HttpClient/HttpClient";
import { timeSince } from "@/helper/DateTimeHelper.js";
import Vue from "vue";
import ViewJobOffer from "@/components/Candidate/ViewJobOffer";

export default Vue.extend({
  name: "CandidateOffers",
  components: { ViewJobOffer, ViewLastJobSearchHistory },
  data: function () {
    return {
      isLoading: false,
      items: [],
      locationItems: [],
      displayAlertErrors: false,
      jobBoardJobModel: null,
      where: null,
      search: null,
      locationSearch: null,
      tab: null,
      locationTab: null,
      selected: [2],
      formErrors: [],
      snackbarAlertSuccess: false,
      snackbarAlertFailed: false,
      jobOffers: [],
      displayLastResearch: true,
      displayResults: false,
      jobsItems: [],
      page: 1,
      perPage: 5,
      displayJobOffer: false,
      jobOfferToView: null,
      renderViewJobModal: false,
      locationIsLoading: false,
    };
  },
  mounted() {
    if (this.$route.query.loadLastResearch === "true") {
      const httpClient = new HttpClient();
      httpClient
        .getLastJobSearch(localStorage.getItem("jwt-token"))
        .then((res) => {
          const jobResearchHistories = res.data;
          if (jobResearchHistories.length > 0) {
            const lastItem = jobResearchHistories[0];
            this.updateFormJob(lastItem);
          }
        });
    }

    // set menu title
    this.$store.commit("updateMenuTitle", "Offres d'emplois");
  },
  computed: {
    updateVisibleJobs: function () {
      return this.jobsItems.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  watch: {
    jobBoardJobModel(val) {
      if (val != null) this.tab = 0;
      else this.tab = null;

      if (val.length > 0) {
        this.searchJob();
      }
    },
    search(val) {
      // Items have already been loaded
      if (this.items.length > 0 && val) {
        const result = this.items.filter(
          (value) =>
            value.name.toLowerCase() === val.toLowerCase() ||
            value.name.toLowerCase().search(val.toLowerCase()) !== -1
        );
        if (result.length > 0) {
          return;
        }
      }
      this.isLoading = true;
      const httpClient = new HttpClient();
      httpClient
        .fetchCompanyKeyWordsJobTitleAndActivitySector(
          val,
          localStorage.getItem("jwt-token")
        )
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .finally(() => (this.isLoading = false));
    },
    where(val) {
      if (val != null) this.locationTab = 0;
      else this.locationTab = null;

      if (typeof val === "object") {
        this.searchJob();
      } else if (typeof val === "string" && val.trim() !== "") {
        this.searchJob();
      }
    },
    locationSearch(val) {
      // Items have already been loaded
      if (this.locationItems.length > 0 && val) {
        const result = this.locationItems.filter(
          (value) =>
            value.name.toLowerCase() === val.toLowerCase() ||
            value.name.toLowerCase().search(val.toLowerCase()) !== -1
        );
        if (result.length > 0) {
          return;
        }
      }
      this.locationIsLoading = true;
      const httpClient = new HttpClient();
      httpClient
        .fetchLocations(val, localStorage.getItem("jwt-token"))
        .then((res) => {
          res.data.forEach((elt) => {
            this.locationItems.push({
              name: elt.jobLocation,
            });
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .finally(() => (this.locationIsLoading = false));
    },
  },
  methods: {
    searchJob: function () {
      const httpClient = new HttpClient();
      let searchContent = [];
      let jobLocation = "";
      if (this.jobBoardJobModel !== null && this.jobBoardJobModel.length > 0) {
        this.jobBoardJobModel.forEach((elt) => {
          if (typeof elt === "object") {
            searchContent.push(elt.name);
          } else {
            searchContent.push(elt);
          }
        });
      }

      if (typeof this.where === "object" && this.where !== null) {
        jobLocation = this.where.name;
      } else if (typeof this.where === "object" && this.where == null) {
        jobLocation = null;
      } else {
        jobLocation = this.where;
      }

      httpClient
        .getJobOffers(
          {
            searchContent: searchContent,
            jobLocation: jobLocation,
          },
          localStorage.getItem("jwt-token")
        )
        .then((value) => {
          this.jobOffers = value.data;
          this.jobsItems = [];
          value.data.map((elt) => {
            this.jobsItems.push({
              id: elt.id,
              action: timeSince(new Date(elt.createdAt)),
              headline: elt.company.name,
              subtitle: elt.description,
              title: elt.job.name + " - " + elt.type.name,
            });
          });
          this.displayResults = true;
          this.displayLastResearch = false;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
    updateFormJob: function (searchHistory) {
      this.jobBoardJobModel = [];
      this.where = {
        name: searchHistory.location,
      };
      searchHistory.what.split("`JB-WORDS-SEPARATOR`").forEach((elt) => {
        this.jobBoardJobModel.push({
          name: elt,
        });
      });

      this.searchJob();
    },
    createNewAlert: function () {
      console.log(this.jobBoardJobModel)
      this.displayAlertErrors = false;
      const httpClient = new HttpClient();
      let searchContent = [];
      let jobLocation = "";
      if (!this.jobBoardJobModel || this.jobBoardJobModel.length === 0) {
        this.displayAlertErrors = true;
        return;
      }

      this.jobBoardJobModel.forEach((elt) => {
        if (typeof elt === "object") {
          searchContent.push(elt.name);
        } else {
          searchContent.push(elt);
        }
      });

      if(this.where) {

        if (typeof this.where === "object") {
          jobLocation = this.where.name;
        } else {
          jobLocation = this.where;
        }

      }

      httpClient
        .createNewJobOffersAlert(
          {
            searchContent: searchContent,
            jobLocation: jobLocation,
          },
          localStorage.getItem("jwt-token")
        )
        .then((value) => {
          this.snackbarAlertSuccess = true;
          setTimeout(() => {
            this.snackbarAlertSuccess = false;
          }, 3000);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else if (error.response.status === 503) {
            this.snackbarAlertFailed = true;
            setTimeout(() => {
              this.snackbarAlertFailed = false;
            }, 3000);
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
    viewJobOffer: function (offerId) {
      const offer = this.jobOffers.filter((elt) => elt.id === offerId);
      if (offer.length !== 1) {
        alert("une erreur s'est produite");
      } else {
        this.jobOfferToView = offer[0];
        this.displayJobOffer = true;
        this.renderViewJobModal = true;
      }
    },
    hideModalComponent: function () {
      this.renderViewJobModal = false;
    },
    locationFieldKeyUpListerner: function (event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        this.searchJob();
      }
    },
  },
});
</script>

<style scoped></style>
